export interface FilamentConfig {
    nozzle_temp_min: string;
    nozzle_temp_max: string;
    bed_temp: string;
    bed_temp_type: string;
}

export interface FilamentConfigs {
    [key: string]: FilamentConfig;
}

export const filamentConfigs: FilamentConfigs = {
    PLA: {
        nozzle_temp_min: "190",
        nozzle_temp_max: "230",
        bed_temp: "60",
        bed_temp_type: "normal"
    },
    ABS: {
        nozzle_temp_min: "220",
        nozzle_temp_max: "270",
        bed_temp: "90",
        bed_temp_type: "high"
    }
};